import styled, { css } from "styled-components/native";
import ImgProgressBar from "./ImgProgressBar";
import { v4 as uuidv4 } from "uuid";
import useGenericContentStore from "../../store/genericContent.store";
import { styleHelper } from "../../StyleHelpers";

interface Props {
	show?: boolean;
	data?: any;
	hideTitle?: boolean;
	isBanner?: boolean;
	isHeroBanner?: boolean;
	isPlaylist?: boolean;
	isVAM?: boolean;
	isHome?: boolean;
	noPaddingTop?: boolean;
	isPreview?: boolean;
	isStudioAccess?: boolean;
}
interface StyledProps extends Props {
	isLandscape?: boolean;
	hideBanner?: boolean;
	hka?: any;
	packshot?: any;
}

const getMarginLeft = (isPreview?: boolean) => {
	return isPreview ? 0 : 60;
};

const getSwiperMarginLeft = (isNarrow?: boolean, isPreview?: boolean, isVAM?: boolean): number => {
	if (isPreview) return 0;
	if (isNarrow) return isVAM ? 0 : 40;
	return 60;
};

const StyledHeroBannerContainer = styled.View<any>`
	margin-bottom: ${(props) => props.rowGap};

	${({ isNarrow, isPreview }) =>
		isNarrow
			? css`
					display: flex;
					flex-direction: row;
					gap: 1rem;
					justify-content: center;
					margin-top: 20px;
					margin-bottom: -3px;
					margin-right: 49px;
				`
			: css`
					width: 100%;
					margin-left: ${getMarginLeft(isPreview)}px;
					margin-top: 20px;
					margin-bottom: -5px;
				`}
`;

const StyledSwiperContainer = styled.View<any>`
	margin-left: ${({ isNarrow, isPreview, isStudioAccess }) => getSwiperMarginLeft(isNarrow, isPreview, isStudioAccess)}px;
	margin-top: ${(props) => (props.isNarrow ? "20px" : "40px")};
	gap: ${(props) => props.rowGap};
`;

const StyledLoadingContainer = styled.View<StyledProps>`
	flex-direction: column;
	${(props) =>
		props.isLandscape &&
		props.isStudioAccess &&
		css`
			width: ${props?.hka?.width};
		`}
`;

const StyledLoading = styled.View<StyledProps>`
	border-radius: 16px;
	overflow: hidden;

	${(props) =>
		props.isLandscape &&
		css`
			width: ${props?.hka?.width};
			height: ${props?.hka?.height};
		`}
	${(props) =>
		!props.isLandscape &&
		css`
			width: ${props?.packshot?.width};
			height: ${props?.packshot?.height};
		`}
`;

const StyledMainRow = styled.View<any>`
	gap: 0.5rem;
`;

const StyledTitle = styled.View<any>`
	height: ${(props) => props.height}px;
	border-radius: 12px;
	overflow: hidden;
	width: 20vw;
	margin-bottom: 0.5rem;
`;

const StyledHeroBanner = styled.View<any>`
	border-radius: 16px;
	overflow: hidden;
	height: auto;
	aspect-ratio: ${4 / 1};
	margin-right: ${(props) => (props.isNarrow ? 0 : props.paddingStart)};
	width: ${(props) => props.width};
`;

const StyledLoaderGrid = styled.View<any>`
	display: flex;
	flex-direction: row;
	flex-wrap: nowrap;
	overflow: hidden;
	gap: ${(props) => props.columnGap};
`;

const StyledLoaderContainer = styled.View<any>`
	width: 100%;
	padding-top: ${(props) => (props?.isHome ? `calc(2rem + ${props.paddingTop})` : props.paddingTop)};
	padding-left: ${(props) => props.paddingStart};
	overflow-x: hidden;
`;

const CustomizeLoader = (props: Props) => {
	const { isNarrow } = useGenericContentStore((state: any) => ({ isNarrow: state.isNarrow }));
	const stylesLayout = isNarrow ? styleHelper.narrow.banner : styleHelper.wide.banner;

	if (!props.show) return <></>;

	return (
		<StyledLoaderContainer
			isNarrow={isNarrow}
			paddingStart={isNarrow && props.isStudioAccess ? "25px" : stylesLayout?.paddingStart}
			isHome={props?.isHome}
			paddingTop={props?.noPaddingTop ? 0 : stylesLayout?.paddingTop}
		>
			{props.isBanner || props.isHeroBanner ? (
				<StyledHeroBannerContainer
					key={`customize-loader-herobanner-container-${uuidv4()}`}
					rowGap={stylesLayout?.rowGap}
					paddingEnd={stylesLayout?.paddingEnd}
					isNarrow={isNarrow}
					isPreview={props.isPreview}
				>
					{props.isBanner && !isNarrow ? (
						<StyledTitle height={stylesLayout?.playlistTitle.lineHeight} key={`customize-loader-herobanner-title-${uuidv4()}`}>
							<ImgProgressBar />
						</StyledTitle>
					) : (
						<></>
					)}
					<StyledHeroBanner
						key={`customize-loader-herobanner-${uuidv4()}`}
						height={stylesLayout?.height}
						width={stylesLayout?.width}
						paddingStart={props?.isHome ? stylesLayout?.columnGap : stylesLayout?.paddingStart}
						isNarrow={isNarrow}
					>
						<ImgProgressBar />
					</StyledHeroBanner>
					{isNarrow ? (
						<>
							<StyledHeroBanner
								key={`customize-loader-herobanner-${uuidv4()}`}
								height={stylesLayout?.height}
								width={stylesLayout?.width}
								paddingStart={stylesLayout?.paddingStart}
								isNarrow={isNarrow}
							>
								<ImgProgressBar />
							</StyledHeroBanner>
							<StyledHeroBanner
								key={`customize-loader-herobanner-${uuidv4()}`}
								height={stylesLayout?.height}
								width={stylesLayout?.width}
								paddingStart={stylesLayout?.paddingStart}
								isNarrow={isNarrow}
							>
								<ImgProgressBar />
							</StyledHeroBanner>
						</>
					) : (
						<></>
					)}
				</StyledHeroBannerContainer>
			) : (
				<></>
			)}
			{props.isPlaylist ? (
				<StyledSwiperContainer
					isPreview={props.isPreview}
					isNarrow={isNarrow}
					isStudioAccess={props.isStudioAccess}
					rowGap={stylesLayout?.rowGap}
				>
					{props.data?.map((val: any) => {
						return (
							<StyledMainRow key={`customize-loader-${val.id}`}>
								{!props.hideTitle ? (
									<StyledTitle height={stylesLayout?.playlistTitle.lineHeight} key={`customize-loader-title-${val.id}`}>
										<ImgProgressBar />
									</StyledTitle>
								) : (
									<></>
								)}
								<StyledLoaderGrid columnGap={stylesLayout?.columnGap}>
									{val?.packshot.map((item: any) => {
										return (
											//@ts-ignore
											<StyledLoadingContainer
												key={`customize-loader-container-${item}`}
												isLandscape={val?.isLandscape}
												isStudioAccess={isNarrow && props.isStudioAccess}
												hka={isNarrow && props.isStudioAccess ? stylesLayout?.hkaStudio : stylesLayout?.hka}
											>
												{/* @ts-ignore */}
												<StyledLoading
													key={`customize-loader-image-${item}`}
													isLandscape={val?.isLandscape}
													hka={isNarrow && props.isStudioAccess ? stylesLayout?.hkaStudio : stylesLayout?.hka}
													packshot={stylesLayout?.packshot}
												>
													<ImgProgressBar />
												</StyledLoading>
												{props.isVAM ? (
													<StyledTitle isVAM={true} key={`vam-loader-title-${item}`}>
														<ImgProgressBar />
													</StyledTitle>
												) : (
													<></>
												)}
											</StyledLoadingContainer>
										);
									})}
								</StyledLoaderGrid>
							</StyledMainRow>
						);
					})}
				</StyledSwiperContainer>
			) : (
				<></>
			)}
		</StyledLoaderContainer>
	);
};

export default CustomizeLoader;
